import { SearchOutlined } from '@mui/icons-material'
import { IconButton, Input, Pagination, TextField } from '@mui/material'
import { Button } from 'components'
import NotFoundMessage from 'components/NotFoundMessage'
import TableLoadingAnimation from 'components/TableLoadingAnimation'
import { cloneDeep } from 'lodash'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { get } from 'services/api'
import { ROUTE_CONSTANTS } from 'utils/constants/routeConstants'
import { gotoUrl } from 'utils/functions'
import downloadFile from 'utils/fileUtils'
import DashboardTable from './DashboardTable'

import styles from './styles'

const initialValues = {
  search: '',
  dateStart: '',
  dateEnd: '',
}

export default function Dashboard() {
  const classes = styles()
  const token = useSelector((state) => state.auth.access_token)
  const [formState, setFormState] = useState(initialValues)
  const [page, setPage] = useState(1)
  const [pagesNumber, setPagesNumber] = useState(1)
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(true)
  const [exportLoading, setExportLoading] = useState(false)

  const handleChangeFormValue = (event) => {
    const key = event.target.id
    const newFormState = cloneDeep(formState)
    newFormState[key] = event.target.value
    setFormState(newFormState)
  }

  const loadData = async () => {
    const { search, dateStart, dateEnd } = formState
    setLoading(true)
    get({
      url: '/antifraude/list',
      token,
      params: {
        search: search !== '' ? search : null,
        date_start: dateStart ? moment(dateStart).format('DD-MM-YYYY') : null,
        date_end: dateEnd ? moment(dateEnd).format('DD-MM-YYYY') : null,
        page,
      },
    })
      .then((response) => {
        setList(response.data.items)
        setPagesNumber(response.data?.total_pages)
      })
      .catch(() => {
        toast.error(
          'Houve um erro ao obter dos dados de antifraude, por favor tente novamente atualizando a página.',
        )
        setList([])
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const handleEnter = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault()
      loadData()
    }
    return false
  }

  const handlePageChange = (event, value) => {
    setPage(value)
  }

  const handleExport = () => {
    const { search, dateStart, dateEnd } = formState
    setExportLoading(true)
    get({
      url: '/antifraude/export',
      token,
      params: {
        search: search !== '' ? search : null,
        date_start: dateStart ? moment(dateStart).format('DD-MM-YYYY') : null,
        date_end: dateEnd ? moment(dateEnd).format('DD-MM-YYYY') : null,
      },
    })
      .then((response) => {
        const filename = `antifraude-candidatos-${moment().format(
          'DD-MM-YYYY_hh:mm:ss',
        )}.xlsx`
        downloadFile(response.data, filename)
        toast.success('Arquivo baixado com sucesso')
      })
      .catch(() => {
        toast.error('Erro ao exportar a tabela, por favor tente novamente')
      })
      .finally(() => {
        setExportLoading(false)
      })
  }

  useEffect(() => {
    loadData()
  }, [formState.dateEnd, formState.dateStart, page])

  return (
    <div className={classes.root}>
      <header className={classes.header}>
        <h2>Antifraude de assessores</h2>
        <div className={classes.searchForm}>
          <div className={classes.leftWrapper}>
            <Input
              type="search"
              id="search"
              placeholder="Digite o nome ou CPF da pessoa"
              value={formState.search}
              onChange={handleChangeFormValue}
              onKeyUp={handleEnter}
              fullWidth
            />
            <IconButton onClick={loadData}>
              <SearchOutlined />
            </IconButton>
          </div>
          <div className={classes.rightWrapper}>
            <TextField
              variant="standard"
              id="dateStart"
              label="Data início:"
              type="date"
              defaultValue={formState.dateStart}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={handleChangeFormValue}
            />
            <TextField
              variant="standard"
              label="Data fim:"
              id="dateEnd"
              type="date"
              defaultValue={formState.dateEnd}
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                min: formState.dateStart,
              }}
              onChange={handleChangeFormValue}
            />
          </div>
        </div>
        <div className={classes.actionsContainer}>
          <div className={classes.buttonsWrapper}>
            <Button onClick={() => gotoUrl(ROUTE_CONSTANTS.ANTIFRAUDE_BLOCKED)}>
              Visualizar bloqueados
            </Button>
            <Button
              onClick={() => gotoUrl(ROUTE_CONSTANTS.ANTIFRAUDE_HISTORY_UNLOCK)}
            >
              Histórico
            </Button>
          </div>
          <Button onClick={handleExport} loading={exportLoading}>
            Exportar
          </Button>
        </div>
      </header>
      <article className={classes.table}>
        {loading ? (
          <TableLoadingAnimation />
        ) : list.length > 0 ? (
          <DashboardTable tableData={list} />
        ) : (
          <NotFoundMessage message="Não foi encontrado nenhum processo de antifraude" />
        )}
      </article>
      <footer className={classes.pagination}>
        <Pagination
          count={pagesNumber}
          page={page}
          onChange={handlePageChange}
        />
      </footer>
    </div>
  )
}
